import { render, staticRenderFns } from "./product.vue?vue&type=template&id=a8a496f8&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a496f8",
  null
  
)

export default component.exports